export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13366.1ad56144.jpg";